import { COLORS } from "shared/config/constants";

export type ManagerEmployeeStatusVariant = "active" | "deactivated" | "pending";

type EmployeeStatusSource = {
  isActive: boolean;
  accountSetupPending?: boolean;
};

/** Labels/colors for manager employee list + detail; backend derives pending via invitation acceptance. */
export function getManagerEmployeeStatusDisplay(employee: EmployeeStatusSource): {
  label: string;
  variant: ManagerEmployeeStatusVariant;
} {
  if (!employee.isActive) {
    return { label: "Deactivated", variant: "deactivated" };
  }
  if (employee.accountSetupPending === true) {
    return { label: "Pending", variant: "pending" };
  }
  return { label: "Active", variant: "active" };
}

const STATUS_COLOR: Record<ManagerEmployeeStatusVariant, string> = {
  active: COLORS.violetTheme.green,
  deactivated: COLORS.primary,
  pending: COLORS.paymentHistory.late30Days,
};

export function getManagerEmployeeStatusColor(
  variant: ManagerEmployeeStatusVariant
): string {
  return STATUS_COLOR[variant];
}
